import type { FormEvent } from 'react';

type NumericInputKeyboardEvent = {
  key: string;
  ctrlKey: boolean;
  metaKey: boolean;
  altKey: boolean;
  preventDefault: () => void;
};

const DEFAULT_ALLOWED_NON_DIGIT_KEYS = new Set([
  'Backspace',
  'Tab',
  'Delete',
  'ArrowLeft',
  'ArrowRight',
  'Home',
  'End',
]);

const isSingleDigitKey = (key: string) => /^[0-9]$/.test(key);

export const preventNonNumericInputKeyDown = (
  event: NumericInputKeyboardEvent,
  additionalAllowedKeys: readonly string[] = []
) => {
  if (event.ctrlKey || event.metaKey || event.altKey) {
    return;
  }

  if (
    DEFAULT_ALLOWED_NON_DIGIT_KEYS.has(event.key) ||
    additionalAllowedKeys.includes(event.key) ||
    isSingleDigitKey(event.key)
  ) {
    return;
  }

  event.preventDefault();
};

export const preventNonNumericInputBeforeInput = (
  event: FormEvent<HTMLInputElement>
) => {
  const inputData = (event.nativeEvent as InputEvent).data;

  if (inputData === null) {
    return;
  }

  if (!/^[0-9]+$/.test(inputData)) {
    event.preventDefault();
  }
};
